<template>
  <div class='default-detailed-issue-body'>
    <div class="description-block" v-if='issue.description'>
      <div class="data-title">{{$t('detailed.issue.description.title')}}</div>
      <div class="text-container">
        {{issue.description}}
      </div>
    </div>
    <div class="data-row" v-if='issue.exploit'>
      <div class="details-column">
        <div class="data-title">{{$t('issueDataPopup.port')}}</div>
        <div> {{issue.technicalData.port}} </div>
      </div>
      <div class="details-column">
        <div class="data-title">{{$t('issueDataPopup.protocol')}}</div>
        <div> {{issue.technicalData.service}} </div>
      </div>
      <div class="details-column">
        <div class="data-title">{{$t('issueDataPopup.version')}}</div>
        <div> {{issue.technicalData.version}} </div>
      </div>
    </div>
    <div class="technical-block">
      <div class="data-title">{{$t('issueDataPopup.technical.data')}}</div>
      <div class="details-column technical-data" v-if="urls.length > 0">
        <div class="data-sub-title">{{$t('issueDataPopup.url')}}</div>
        <div class='url-section' v-for='(url, index) in urls' :key='index'>
          <div class='data-title option'>
              <span class="material-icons bullet">
                lens_blur
              </span>
          </div>
          <a :href='url' target="_blank"> {{url}} </a>
        </div>
      </div>
      <div class="details-column technical-data" v-if='issue.technicalData && issue.technicalData.param && issue.technicalData.param.length > 0 && issue.technicalData.param[0].length'>
        <div class="data-sub-title">{{$t('issueDataPopup.matcher.name')}}</div>
        <div class='url-section'>
          <div class='data-title option'>
              <span class="material-icons bullet">
                lens_blur
              </span>
          </div>
          <span class='text-container'> {{ issue.technicalData.param[0] || '' }} </span>
        </div>
      </div>
      <div class="details-column technical-data" v-if='evidences.length'>
        <div class="data-sub-title">{{$t('issueDataPopup.evidence')}}</div>
        <div class='url-section' v-for='(evidence, index) in evidences' :key='index'>
          <div class='data-title option'>
              <span class="material-icons bullet">
                lens_blur
              </span>
          </div>
          <div class='text-container'> {{evidence}} </div>
        </div>
      </div>
    </div>
    <span class="solution-block" v-if='solutions.length'>
          <div class="data-title">{{$t('detailed.issue.mitigation.title')}}</div>
          <div v-for='(solution, index) in solutions' :key='index'>
             <div class='mitigation-option'>
             <div class='data-title option'>
              <span class="material-icons bullet">
                lens_blur
              </span>
              </div>
               <div class='text-container'>{{solution}}</div>
            </div>
          </div>
        </span>
    <span class="reference-block" v-if='reference.length'>
          <div class="data-title">{{$t('detailed.issue.reference.title')}}</div>
          <div class='text-container' v-for='(reference, index) in reference' :key='index'>
            <div class='url-section'>
              <div class='data-title option'>
                <span class="material-icons bullet">
                  lens_blur
                </span>
              </div>
              <a :href="reference" target="_blank"> {{ reference }} </a>
            </div>
          </div>
        </span>
  </div>
</template>

<script>

export default {
  name: 'DefaultDetailedIssueBody',
  props: {
    issue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reference() {
      return this.issue.reference || this.issue.metaData?.findingsData?.reference || [];
    },
    solutions() {
      return [this.issue.solution || this.issue.metaData?.findingsData?.solution || []]?.filter(solution => solution?.length > 0) || [];
    },
    urls() {
      if (this.issue.technicalData?.url) {
        if (this.issue.technicalData.url.length > 5) {
          return this.issue.technicalData.url.slice(0, 5);
        }
        return this.issue.technicalData.url;
      }
      return [];
    },
    evidences() {
      return this.issue.technicalData?.evidence || [];
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.default-detailed-issue-body {
  .rest-part {
    max-height: rem(610);
    overflow-y: auto;
    scrollbar-width: thin;
    padding-left: $space-15;
    padding-top: $space-8;
    padding-bottom: $space-15;
    background-image: url("../../assets/half-cynergy-logo.svg");
    background-size: contain;
    background-position: right;
  }
  .description-block {
    display: block;
    width: rem(650);
    .text-container::first-letter {
      text-transform: capitalize;
    }
    .text-container {
      padding-right: $space-15;
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-9;
    }
  }
  .solution-block {
    display: block;
    padding-bottom: $space-5;
    width: rem(650);
    .bullet {
      flex: 1;
    }
    .text-container {
      padding-left: rem(5);
      padding-right: $space-15;
      color: var(--text-primary);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-4;
    }
    .mitigation-option {
      display: flex;
    }
    .material-icons {
      font-size: rem(15);
      opacity: 0.5;
      margin-top: rem(3);
    }
  }
  .reference-block {
    padding-bottom: $space-5;
    display: block;
    width: rem(650);
    .text-container {
      padding-right: $space-15;
      color: var(--text-primary);
      font-size: $font-size-base;
      letter-spacing: 0;
      line-height: rem(18);
      padding-bottom: $space-4;
    }
    .url-section {
      display: flex;
      .bullet {
        padding-right: rem(5);
      }
      .material-icons {
        font-size: rem(15);
        opacity: 0.5;
        margin-top: rem(1);
      }
    }
  }
  .technical-block {
    padding-bottom: $space-5;
    display: block;
    width: rem(650);
    .url-section {
      .bullet {
        padding-right: rem(5);
      }
      .text-container {
        padding-left: rem(5);
        padding-right: $space-15;
        color: var(--text-primary);
        font-size: $font-size-base;
        letter-spacing: 0;
        line-height: rem(18);
        padding-bottom: $space-4;
        max-width: rem(700);
      }
      display: flex;
      .material-icons {
        font-size: rem(15);
        opacity: 0.5;
        margin-top: rem(3);
      }
    }
    .technical-data {
      padding-top: $space-1;
    }
  }
  .data-sub-title {
    font-size: $font-size-xs;
    color: var(--text-secondary);
    letter-spacing: 0.8px;
    line-height: rem(10);
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .data-title {
    color: var(--text-secondary);
    font-size: $font-size-sm;
    letter-spacing: 0.8px;
    line-height: rem(10);
    text-transform: uppercase;
    margin-bottom: $space-1;
  }
  .data-row {
    margin-top: $space-6;
    padding-bottom: $space-9;
    .details-column {
      display: inline-block;
      width: fit-content;
      max-width: rem(650);
      margin-right: $space-4;
    }
    .data-column {
      display: inline-block;
      min-width: rem(90);
      max-width: rem(120);
      margin-right: $space-4;

      .probability {
        line-height: unset;
      }
    }

    .data-column-date {
      display: inline-block;
      width: rem(135);
      margin-right: $space-4;
    }
  }
}
</style>
